import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Alarm"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18.3112 2.99609L17.25 4.05584L19.9358 6.74759L20.997 5.68784L18.3112 2.99609ZM3 5.69383L5.6865 3.00208L6.7485 4.06183L4.062 6.75358L3 5.69383ZM13.9425 15.7499L11.25 13.0574V8.24987H12.75V12.4349L15 14.6924L13.9425 15.7499ZM12 20.9999C7.44365 20.9999 3.75 17.3062 3.75 12.7499C3.75 8.19353 7.44365 4.49988 12 4.49988C16.5563 4.49988 20.25 8.19353 20.25 12.7499C20.25 14.9379 19.3808 17.0363 17.8336 18.5835C16.2865 20.1307 14.188 20.9999 12 20.9999ZM5.25 12.7499C5.25 9.02196 8.27208 5.99988 12 5.99988C15.7279 5.99988 18.75 9.02196 18.75 12.7499C18.75 16.4778 15.7279 19.4999 12 19.4999C8.27208 19.4999 5.25 16.4778 5.25 12.7499Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Alarm.vue"]]);
